<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <!-- Main content -->
      <section class="content">

        <div class="box citic-box">
          <!-- 待确认和已确认 -->
          <el-tabs
            v-model="activeName"
            @tab-click="handleClick"
          >
            <el-tab-pane
              label="待确认"
              name="1"
            >
              <el-table
                :data="uncomfirmList"
                style="width:100%;margin-bottom: 20px;"
                border
              >
                <el-table-column
                  prop="paytime"
                  label="收款时间"
                  width="180"
                  fixed
                ></el-table-column>
                <el-table-column
                  prop="factory_qc_name"
                  label="厂商名称"
                  width="180"
                  fixed
                ></el-table-column>
                <el-table-column
                  prop="factory_short_name"
                  label="厂商简称"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="nickname"
                  label="管理员姓名"
                  width="100"
                ></el-table-column>
                <el-table-column
                  prop="account_phone"
                  label="管理员手机号"
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="order_type"
                  label="付款方式"
                ></el-table-column>
                <el-table-column
                  prop="total_fee"
                  label="付款金额"
                  width="180"
                ></el-table-column>
                <el-table-column
                  label="确认收款"
                  width="180"
                >
                  <template slot-scope="scope">
                    <!-- <el-button @click="changeStatus(scope.row)">{{ scope.row.paymark === '已开票' ? '确认' : '已确认' }}</el-button> -->
                    <el-button
                      @click="changeStatus(scope.row)"
                      type="primary"
                    >待确认</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页 -->
              <div class="table-list__footer">
                <el-pagination
                  @current-change="handlePageChangeOne"
                  :current-page="currentPage.one"
                  :page-size="page_size"
                  layout="total, prev, pager, next, jumper"
                  :total="totalOne"
                >
                </el-pagination>
              </div>
            </el-tab-pane>
            <el-tab-pane
              label="已确认"
              name="2"
            >
              <!-- table内容 -->
              <el-table
                :data="comfirmList"
                border
                style="width:100%;margin-bottom: 20px;"
              >
                <el-table-column
                  prop="paytime"
                  label="收款时间"
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="factory_qc_name"
                  label="厂商名称"
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="factory_short_name"
                  label="厂商简称"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="nickname"
                  label="管理员姓名"
                  width="100"
                ></el-table-column>
                <el-table-column
                  prop="account_phone"
                  label="管理员手机号"
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="order_type"
                  label="付款方式"
                ></el-table-column>
                <el-table-column
                  prop="total_fee"
                  label="付款金额"
                  width="180"
                ></el-table-column>
                <el-table-column
                  prop="paymark"
                  label="确认收款"
                  width="180"
                >
                  <template>
                    <!-- <el-button @click="changeStatus(scope.row)">{{ scope.row.activeName === '2' ? '已确认' : '待确认' }}</el-button> -->
                    <el-button
                      @click="changeStatus(scope.row)"
                      type="info"
                      disabled
                    >已确认</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <!-- 分页 -->
              <div class="table-list__footer">
                <el-pagination
                  @current-change="handlePageChangeTwo"
                  :current-page="currentPage.two"
                  :page-size="page_size"
                  layout="total, prev, pager, next, jumper"
                  :total="totalTwo"
                >
                </el-pagination>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>

      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>

<script>
import axios from 'axios'
import ThePageHeader from '../../partials/ThePageHeader'
import TheSlideBox from '../../partials/TheSlideBox'
import TheSearchBox from '../../widgets/widgetSearchBox'
export default {
  name: 'PostHome',
  components: {
    ThePageHeader,
    TheSlideBox,
    TheSearchBox
  },
  data () {
    return {
      currentPage: {
        one: 1,
        two: 1
      },
      comfirmList: [],
      uncomfirmList: [],
      activeName: '1',
      // currentPage: 1,
      pageSize: 10,
      totalOne: 0,
      totalTwo: 0,
      enterprise_account_id: 1,
      loading: false,
      commodity_order_id: ''
    }
  },
  methods: {
    // tab切换
    handleClick (tab, event) {
      // this.$forceUpdate()
      console.log(this.activeName)
      // this.fetchData()
      console.log(tab, event)
    },
    // 获取页面数据
    fetchData (activeName) {
      let url = this.$config.API.proceeds.makecollections
      this.loading = true
      const pageObj = {
        '1': this.currentPage.one,
        '2': this.currentPage.two
      }
      axios.get(url, {
        params: {
          // page: Number(pageObj[this.activeName]),
          page: Number(pageObj[activeName]),
          // page: this.currentPage,
          enterprise_account_id: this.enterprise_account_id,
          type: Number(activeName)
        }
      }).then(res => {
        // 当type为1时候，排序，确认
        // this.uncomfirmList = res.data.data.commodityorderList
        // this.total = res.data.TOTAL_NUM
        // this.loading = false
        // this.$forceUpdate()
        if (activeName === '2') {
          this.comfirmList = res.data.data.commodityorderList
          this.totalTwo = res.data.TOTAL_NUM
          this.loading = false
        } else {
        // 当type为2时候，排序，待确认
          this.uncomfirmList = res.data.data.commodityorderList
          this.totalOne = res.data.TOTAL_NUM
          this.loading = false
        }
        console.log('1', this.comfirmList)
        console.log('2', this.uncomfirmList)
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 页面分页
    handlePageChangeOne (page) {
      // this.$forceUpdate()
      this.$set(this.currentPage, 'one', page)
      this.$nextTick(function () {
        this.fetchData('1')
      })
    },
    handlePageChangeTwo (page) {
      // this.$forceUpdate()
      this.$set(this.currentPage, 'two', page)
      // this.currentPage.two = page
      // this.fetchData()
      this.$nextTick(function () {
        this.fetchData('2')
      })
    },
    changeStatus (scope) {
      console.log(scope)
      let url = this.$config.API.proceeds.status
      // this.loading = true
      let data = {
        commodity_order_id: scope.id
      }
      axios.post(url, data).then(res => {
        // this.activeName === '2' ? 已确认 : 待确认
        // this.activeName = !this.activeName
        // console.log(this.activeName)
        this.fetchData(this.activeName)
        this.loading = false
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    }
  },
  mounted () {
    this.fetchData('1')
    this.fetchData('2')
  }
}
</script>
<style lang="scss">
.citic-box {
  padding-top: 15px;
  .el-tabs__content {
    overflow: visible !important;
    position: static;
  }
  .box-header {
    ul.nav-tabs {
      margin-bottom: 0 !important;
      border-bottom: 0;
      li > a {
        color: #9ebbcd !important;
      }
      li.active > a {
        color: #333 !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// proceeds.vue?1fc3b652